module.exports = __webpack_public_path__ + "img/0024.47781f66.gif";